<template>
<el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-main-right-container">
        <div class="cs-contentContainer-right">
            <div class="backgroud-white cs-contentContainer-right-content">
                <el-row>
                    <el-col>
                        <span class="cs-title">第二步：登记在校上课时间</span>
                        <el-row>
                            <el-col :span="18" :xs="24" class="backgroud-red cs-contentContainer-right-red">
                                <label v-if="studentEnable">
                                          为了能帮助所有速成学员更合理的安排上课时间，请仔细对照学校的课程表并填入准确信息
                                    </label>
                                <label v-if="!studentEnable">
                                          已过登记在校课程期限。若您已经登记在校课程，请耐心等待通知上课时间。若您还未登记在校课程，请迅速联系速成客服。
                                    </label>
                            </el-col>
                        </el-row>
                        <!-- <el-row class="grid-content" style="height:50px;">&nbsp;</el-row> -->
                        <el-row class="grid-content">
                            <el-row class="cs-courseSchedule-header">
                                <el-col :span="6" :xs="24">
                                    <label class="el-form-item__label">学校：</label>
                                    <label class="el-form-item__content" v-text="universityName"></label>
                                </el-col>
                                <el-col :span="6" :xs="24">
                                    <div>
                                        <label class="el-form-item__label">总课程数量：</label>
                                        <label class="el-form-item__content" style="width:40px;" v-text="studentCourseSummary.Total"></label>
                                        <el-button class="cs-courseSchedule-editButton" v-if="studentEnable" type="text" size="medium" @click="editCourseCount()">编辑</el-button>
                                    </div>
                                </el-col>
                                <el-col :span="4" :xs="24">
                                    <label class="el-form-item__label">已添加课程：</label>
                                    <label class="el-form-item__content" style="width:40px;" v-text="studentCourseSummary.SheduledCourseCount"></label>
                                </el-col>
                                <el-col :span="8" :xs="24" class="cs-schedule-buttonContainer" v-if="studentEnable">
                                    <el-tooltip :disabled="studentCourseSummary.Total > studentCourseSummary.SheduledCourseCount" content="录入的课程数量已达到最大值" class="item" effect="dark" placement="top">
                                        <span>
                                          <el-button :disabled="studentCourseSummary.Total==studentCourseSummary.SheduledCourseCount" :type="btnAddClass" icon="el-icon-plus" @click="addCourse">添加课程</el-button>
                                        </span>
                                    </el-tooltip>
                                    <el-tooltip :disabled="studentCourseSummary.Total == studentCourseSummary.SheduledCourseCount" content="请根据总课程数量录入所有的课程" class="item" effect="dark" placement="top">
                                        <span><el-button :disabled="studentCourseSummary.Total > studentCourseSummary.SheduledCourseCount" :type="btnSubmitClass" @click="submit">保存并提交</el-button></span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <courseCalendar @editBlock="editCourseSchedule" :schedules="courseSchedules"></courseCalendar>
                    </el-col>
                </el-row>

            </div>
        </div>
    </el-col>
    <el-dialog title="添加课程" :center="true" :close-on-click-modal="false" :visible.sync="dialogFormVisible" top="8vh">
        <courseScheduleEditor
            :courseData="courseData"
            :courseDataAll="courseDataAll"
            @save="saveSchedule"
            class="popup-window"
            v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"
        ></courseScheduleEditor>
    </el-dialog>
    <el-dialog class="cs-courseSuccess-container" :visible.sync="courseSuccessdialogVisible">
        <div class="image-container">
            <img src="../assets/success.png">
        </div>
        <div class="text-container">
            <span>成功啦！您的课程信息已提交，<br/>请耐心等候老师通知速成课程的上课时间</span>
        </div>

        <div class="dialog-footer">
            <el-button type="primary" @click="courseSuccessdialogVisible = false">确 认</el-button>
        </div>
    </el-dialog>
</el-row>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    height: auto !important;
    .grid-content {
        margin-top: 15px;
        .cs-schedule-buttonContainer {
            text-align: right;
        }
        .cs-courseSchedule-header{
            .el-form-item__label{
                font-weight: bold;
            }
        }
    }
    .cs-schedule-bottomButton {
        margin-top: 20px;
    }
    .cs-courseSuccess-container {
        .image-container {
            text-align: center;
            width: 100%;
            margin-top: 20px;
        }
        .text-container {
            text-align: center;
            width: 100%;
            margin-top: 40px;
            margin-bottom: 40px;
            padding: 0 10%;
            span {
                font-weight: bold;
            }
        }
        .dialog-footer {
            width: 100%;
            text-align: center;
            margin-bottom: 30px;
        }
    }
}
</style>

<script>
import courseCalendar from "../components/courseCalendar";
import navigator from "../components/navigator";
import courseScheduleEditor from "../components/courseScheduleEditor.vue";
import {
    getStore,
    getColorList
} from "../config/mUtils";
import {
    saveCourseCount,
    getStudentCourseCount,
    getStudentCourse,
    setStudentConfig
} from "../service/course.service";

export default {
    data() {
        return {
            courseSuccessdialogVisible: false,
            btnAddClass: "primary",
            btnSubmitClass: "info",
            dialogFormVisible: false,
            universityName: "",
            isUTM:false,
            isUTSG:false,
            courseSchedules: [],
            courseDataAll: [],
            courseData: [],
            studentEnable: true,
            studentCourseSummary: {
                Id: 0,
                TermId: 0,
                StudentId: 0,
                Total: 0,
                SheduledCourseCount: 0
            },
            rules: {
                CourseCount: [{
                    required: true,
                    message: "请选择课程数量",
                    trigger: "blur"
                }]
            }
        };
    },
    created() {
        this.universityName = getStore("user_student_universityName");
        let universityAbbreviation = getStore("user_student_universityAbbreviation");
        if (!!universityAbbreviation && universityAbbreviation.indexOf("UTM") >= 0){
            this.isUTM = true;
        }
        if (!!universityAbbreviation && universityAbbreviation.indexOf("UTSG") >= 0){
            this.isUTSG = true;
        }
        
        this.loadStudentCourse();
        this.getCourseCount();
        let stEnable = getStore("user_student_enable");
        if (stEnable == '0') {
            this.studentEnable = false;
        } else {
            this.studentEnable = true;
        }
        //his.getBtnClass();
    },
    components: {
        navigator,
        courseCalendar,
        courseScheduleEditor
    },
    methods: {
        getCourseCount() {
            getStudentCourseCount(getStore("user_student_id")).then(result => {
                if (!!result && result.success) {
                    this.studentCourseSummary.Id = result.data.Id;
                    //this.studentCourseSummary.TermId = result.data.model.termId;
                    this.studentCourseSummary.StudentId = result.data.StudentId;
                    this.studentCourseSummary.Total =
                        result.data.Total == 0 ? "" : result.data.Total.toString();
                    this.studentCourseSummary.SheduledCourseCount =
                        result.data.SheduledCourseCount;
                    //this.studentCourseSummary.UniversityName = result.data.model.universityName;
                    //this.btnClass = "primary";
                    //console.log(this.studentCourseSummary.Total);
                    //console.log(this.studentCourseSummary.SheduledCourseCount);
                    this.getBtnClass();
                }
            });
        },
        editCourseCount() {
            this.$router.push("/courseCount");
        },
        editCourseSchedule(keyValue) {
            if (!this.studentEnable)
                return;

            let array = keyValue.split('_');
            if (array.length <=1){
                return;
            }
            let isSpeedupCourse = array[0] == "2";
            let id = parseInt(array[1]);

            if (isSpeedupCourse)
                return;

            if (!!this.courseDataAll) {
                let course = this.courseDataAll.filter(i => i.Id == id && !i.IsSpeedupCourse);
                if (course.length > 0) {
                    this.courseData = {
                        id: course[0].Id,
                        courseName: course[0].CourseName,
                        schedules: course[0].ScheduleList,
                        isEdit: true
                    };
                    this.dialogFormVisible = true;
                }
            }
        },
        addCourse() {
            if (!this.studentEnable)
                return;

            this.courseData = {
                id: 0,
                courseName: "",
                schedules: [],
                isEdit: false
            };
            this.dialogFormVisible = true;
        },
        onDialogFormVisibleEvent(visible) {
            this.$data.dialogFormVisible = visible;
        },
        submit() {
            if (
                this.studentCourseSummary.Total >
                this.studentCourseSummary.SheduledCourseCount
            ) {
                this.$message({
                    message: "请先录入所有课程",
                    type: "warning"
                });
                return false;
            }

            let studentId = getStore("user_student_id");
            setStudentConfig(studentId).then(result => {
                if (result.success) {
                    this.courseSuccessdialogVisible = true;
                } else {
                    if (result.message) {
                        this.$message({
                            message: result.message,
                            type: "warning"
                        });
                    }
                }
            });
        },
        saveSchedule(data, type) {
            this.dialogFormVisible = false;
            this.loadStudentCourse();
            if (type == 1) {
                //增加
                this.studentCourseSummary.SheduledCourseCount++;
                this.getBtnClass();
            } else if (type == 3) {
                //删除
                this.studentCourseSummary.SheduledCourseCount--;
                this.getBtnClass();
            }
        },
        getBtnClass() {
            if (
                this.studentCourseSummary.SheduledCourseCount ==
                this.studentCourseSummary.Total
            ) {
                this.btnAddClass = "info";
                this.btnSubmitClass = "primary";
            } else {
                this.btnAddClass = "primary";
                this.btnSubmitClass = "info";
            }
        },
        loadStudentCourse() {
            getStudentCourse(getStore("user_student_id")).then(result => {
                if (result.success) {
                    this.courseDataAll = result.data;
                    let colorList = getColorList();
                    let scheduleList = [];
                    let courseColor = {};
                    let index = 0;
                    result.data.forEach(course => {
                        let courseName = course.CourseName;
                        let courseId = course.Id;
                        let key = "1";
                        if (course.IsSpeedupCourse){
                            key = "2";
                        }
                        key = key + "_" + courseId;
                        if (!courseColor[key]) {
                            let color = colorList[index];
                            courseColor[key] = color;
                            index++;
                        }

                        course.ScheduleList.forEach(element => {
                            let dayofweek = element.DayOfWeek;
                            if (dayofweek == 0) {
                                dayofweek = 7;
                            }
                            let item = {
                                color: courseColor[key],
                                starttime: element.StartTimeText,
                                endtime: element.EndTimeText,
                                dayofweek: dayofweek,
                                title: courseName,
                                text: "",
                                tooltipText: element.StartTimeText + " - " + element.EndTimeText,
                                keyValue:key,
                                //keyValue: courseId,
                                dataId: element.Id
                            };
                            scheduleList.push(item);
                        });
                    });

                    this.courseSchedules = scheduleList;
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/courseSchedule.vue